module.exports = __webpack_public_path__ + "img/indep.9a33cf9e.png";